export default "__VITE_ASSET__Cxurtw9z__"